<script>
    import _ from 'lodash'
    // import $ from 'jquery'
    import ImageService from '@/request/file/image'
    import draggable from 'vuedraggable'
    import NormcaseService from '@/request/databank/NormCase'
    import NormcaseParagraphService from '@/request/databank/NormCaseParagraph'
    import RecordService from '@/request/record/record'
    import RecordImageService from '@/request/record/recordImage'
    import RecordCourseService from '@/request/record/recordCourse'
    import '@/assets/icon/iconfont.css'
    export default {
      components: {
        draggable
      },
      data () {
        return {
          id: parseInt(this.$route.params.id) || 0,
          rid: parseInt(this.$route.params.rid) || 0,
          back: {},
          normcase: {},
          imageMark: null,
          paragraphs: [],
          editList: [],
          editType: null,
          editParagraph: {},
          draggableOptions: {
            draggable: '.draggable-item'
          },
          saving: false,
          waitId: false,
          recordCourse: {},
          deleteing: false,
          focusIndex:0,//获取焦点的元素
          toolsClass:[],
          percentage:0
        }
      },
      created: function () {
        this.loadNormcase()
        this.listParagraph()
      },
      mounted: function () {},
      beforeDestroy: function () {},
      watch: {
        //拖拽排序
        editList () {
          this.listOrderNumber()
        },
        //保存按钮
        waitId (newVal, oldVal) {
          if (!this.saving) {
            return
          }
          if (oldVal && !newVal) {
            this.saveParagraph()
          }
        },
        //图片
        normcase () {
          this.updateImageMark()
        }
      },
      methods: {
        //后退
        backPage () {
          if (!this.rid) {
            this.$router.push({name: 'databank_normcase'})
          } else {
            this.$router.go(-1)
          }
        },
        //文章信息
        loadNormcase () {
          if (!this.id && !this.rid) {
            this.normcase = {}
            this.back = {}
            return
          }
          if (this.id) {
            NormcaseService.load({
              id: this.id
            }).then(res => {
              this.normcase = _.clone(res.result || {})
              this.back = _.cloneDeep(this.normcase)
            })
          } else {
            RecordService.load({
              id: this.rid
            }).then(data => {
              let record = data.result || {}
              if (_.isEmpty(record)) {
                this.normcase = {}
                this.back = {}
                return
              }
              let nc = {
                sn: record.sn,
                title: record.diagnoseNames,
                operator: record.operator,
                operatorName: record.operatorName,
                sex: record.sex,
                age: record.age,
                diagnose: record.diagnose,
                diagnoseNames: record.diagnoseNames,
                operatingIds: record.operatingIds,
                operatingNames: record.operatingNames,
                arrangedStartTime: record.arrangedStartTime,
                oid: record.oid,
                orgName: record.orgName,
                hid: record.hid,
                hname: record.hname,
                publicType: 1
              }
              this.normcase = _.clone(nc)
              this.back = _.cloneDeep(this.normcase)
            })
          }
        },
        //列表排序
        listOrderNumber () {
          let list = this.editList
          let changed = false
          if (_.isEmpty(list)) {
            list.push({
              ncid: this.id,
              thumbnail: null,
              image: null,
              orderNum: 0,
              type: 2
            })
            changed = true
          } else {
            for (let i = 0, l = list.length; i < l; i++) {
              if (list[i].orderNum !== i) {
                list[i].orderNum = i
                changed = true
              }
            }
          }
          if (changed) {
            this.editList = _.clone(list)
          }
        },
        //初始化列表
        listParagraph () {
          if (!this.id && !this.rid) {
            this.paragraphs = []
            this.editList = []
            return
          }
          if (this.id) {
            NormcaseParagraphService.list({
              ncid: this.id
            }).then(res => {
              let data = _.clone(res.result || [])
              this.paragraphs = _.sortBy(data, 'orderNum')
              this.editList = !_.isEmpty(this.paragraphs) ? _.cloneDeep(this.paragraphs) : []
            }).catch(error => {
              this.$message.error(error || '获取段落出错')
            })
          } else {
            this.generateRecordList()
          }
        },
        //初始化列表
        generateRecordList () {
          if (!this.rid) {
            return
          }
          this.editList = []
          RecordImageService.listImage({
            rid: this.rid
          }).then(res => {
            if (_.isEmpty(res.result)) {
              return
            }
            let list = []
            _.forEach(res.result, value => {
              list.push({
                ncid: this.id,
                thumbnail: value.thumbnail,
                image: value.image,
                width: value.width,
                height: value.height,
                orderNum: value.orderNum,
                type: value.type,
                remark: value.remark
              })
            })
            if (!_.isEmpty(list)) {
              let el = _.cloneDeep(this.editList)
              _.remove(el, item => {
                return !item.ncid && !item.image && !item.remark
              })
              this.editList = _.concat([], el, list)
            }
          })
          RecordCourseService.list({
            rid: this.rid
          }).then(res => {
            let rcs = res.result || []
            if (_.isEmpty(rcs)) {
              return
            }
            let rcids = []
            this.recordCourse = {}
            _.forEach(rcs, value => {
              this.recordCourse[value.id] = _.cloneDeep(value)
              rcids.push(value.id)
            })
            RecordCourseService.listImage({
              dcids: _.join(rcids)
            }).then(images => {
              images = images.result || []
              if (_.isEmpty(images)) {
                return
              }
              let list = []
              _.forEach(images, image => {
                if (this.recordCourse[image.dcid]) {
                  list.push({
                    ncid: this.id,
                    thumbnail: null,
                    image: null,
                    width: null,
                    height: null,
                    orderNum: image.orderNum,
                    type: null,
                    remark: this.recordCourse[image.dcid].remark
                  })
                  delete this.recordCourse[image.dcid]
                }
                list.push({
                  ncid: this.id,
                  thumbnail: image.thumbnail,
                  image: image.image,
                  width: image.width,
                  height: image.height,
                  orderNum: image.orderNum,
                  type: image.type,
                  remark: image.remark
                })
              })
              if (!_.isEmpty(list)) {
                let el = _.cloneDeep(this.editList)
                _.remove(el, item => {
                  return !item.ncid && !item.image && !item.remark
                })
                this.editList = _.concat([], el, list)
              }
            })
          })
        },
        //工具栏显示
        toolStyle(arrTools){
            this.toolsClass = [];
            arrTools.map(arrTools => {
                this.toolsClass.push(arrTools);
            }); 
        },
        //上传图片是否显示
        updateImageMark () {
          let im = this.imageMark
          if (!_.isEmpty(this.normcase) && this.normcase.hname) {
            im = this.normcase.hname
          } else if (!_.isEmpty(this.normcase) && this.normcase.orgName) {
            im = this.normcase.orgName
          }
          this.imageMark = im
        },
        //拖拽
        handleMoveEnd (evt) {
          if (this.editType === null) {
            return
          }
          if (evt.oldIndex === evt.newIndex) {
            return
          }
          if (evt.oldIndex === this.editType) {
            this.editType = evt.newIndex
            return
          }
          if (evt.oldIndex > evt.newIndex) {
            if (evt.oldIndex < this.editType) {
              return
            }
            this.editType = this.editType + 1
          } else {
            if (evt.oldIndex > this.editType) {
              return
            }
            this.editType = this.editType - 1
          }
        },
        //左侧边栏删除
        del (event, index) {
          event.stopPropagation()
          if (index < 0) {
            return
          }
          this.$confirm('确定删除本段?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let item = this.editList.splice(index, 1)
            if (_.isEmpty(item)) {
              return
            }
            item = item[0]
            if (!item.id) {
              return
            }
            NormcaseParagraphService.delete({
              id: item.id
            }).catch(error => {
              this.$message.error(error || '删除段落失败')
              this.editList.splice(index, 0, item)
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消删除'
            })
          })
          this.toolsClass=[];
        },
        //左侧边栏添加事件
        add (index) {
          if (index < 0) {
            return
          }
          this.editList.splice(index, 0, {
            ncid: this.id,
            thumbnail: null,
            image: null,
            orderNum: index,
            type: 2,
            remark:''
          });
          this.editType = index;
          this.focusIndex = index;
          this.toolsClass=[];
        },
        //左侧边栏点击事件
        selectParagraph (event, index) {
          event.stopPropagation()
          if (index < 0) {
            return
          }
          this.editType = index
          if(this.editList[0].remark !== undefined&&this.editList[0].remark !== null&&this.editList[0].remark !== ''){
              this.focusIndex = -1;
          }
          this.handleToIndex(index);
        },
        handleToIndex(index){//点击左侧字母跳到对应的内容块
            var innerbox = document.getElementsByClassName('main-paragraph')[index];
            if(innerbox !== undefined){
                var innerBoxTop = innerbox.offsetTop;// 获取弹框距离顶部高度
                $(".paragraph_add").scrollTop(innerBoxTop-61);
                document.getElementById('paragraph_'+(index)).focus();
            }
        },
        //预览
        preview () {
          this.editType = null
        },
        //保存
        save () {
          this.waitId = false
          if (_.isEmpty(this.normcase)) {
            this.$message.error('病例基本信息不能为空')
            return
          }
          this.saving = true
          if (!this.id) {
            this.waitId = true
          } else {
            this.saveParagraph()
          }
          if (this.id && _.isEqual(this.back, this.normcase)) {
            if (!this.waitId) {
              this.saving = false
            }
            return
          }
          NormcaseService.save(this.normcase).then(res => {
            this.normcase = _.clone(res.result || {})
            this.id = this.normcase.id || 0
            if (!this.id) {
              this.saving = false
            }
            this.waitId = false
          }).catch(error => {
            this.saving = false
            this.$message.error(error || '保存宣传病例失败')
          })
        },
        share () {},
        //改变侧边栏的数组
        changeLeft(index,text){
            if(text == undefined){
                this.$set(this.editList[index], 'remark','');
            }else{
                this.$set(this.editList[index], 'remark',text);
            }
            this.focusIndex = index;
        },
        //上传图片
        uploadFiles(type,file,changtype,index){
            let self = this;
            this.focusIndex=index;
            this.editList.splice(index,changtype,{image:'noUpload'});
            if(type == 0){
                ImageService.uploadImage(file,this.imageMark,'large',this.handleProgress).then(uimg => {
                    uimg = uimg.result
                    uimg.type = 'image';
                    self.handleUploadImageSuccess(uimg,changtype,index)
                }).catch(error => {
                    self.$message.error(error);
                })
            }else{
                ImageService.uploadVideo(file,this.handleProgress).then(uvideo => {
                    uvideo = uvideo.result
                    self.handleUploadImageSuccess(uvideo,changtype,index)
                }).catch(error => {
                    self.$message.error(error);
                })
            }
        },
        handleProgress(e){
            this.percentage = Math.floor(e.percent);
        },
        handleUploadImageSuccess (data,changtype,index) {
            let type = data.type;
            let thumbnail = type === 'image' ? data.small : data.cover;
            let image = type === 'image' ? data.large : data.location;
            let item = {
                thumbnail: thumbnail,
                image: image,
                width: data.width || 1024,
                height: data.height || 768
            }
            this.addPic(index,item,changtype);
        },
        //添加图片
        addPic(index,item){
            _.assign(this.editList[index],item);
            this.percentage = 0;
        },
        //删除图片
        delPic(index,item){
            _.assign(this.editList[index],item); 
        },
        //保存段落
        saveParagraph () {
          if (!this.id) {
            this.saving = false
            return
          }
          if (_.isEmpty(this.editList)) {
            this.saving = false
            return
          }
          let ps = []
          for (let i = 0, l = this.editList.length; i < l; i++) {
            let item = this.editList[i]
            item.sn = this.normcase.sn
            item.ncid = this.id
            if (_.isEqual(item, this.paragraphs[i])) {
              continue
            }
            ps.push(NormcaseParagraphService.save(item))
          }
          Promise.all(ps).then(() => {
            this.listParagraph()
            this.$message({
              message: '保存宣传病例成功',
              type: 'success'
            })
          }).finally(() => {
            this.saving = false
          })
        },
        //删除
        deleteNc () {
          if (!this.id) {
            this.deleteing = false
            return
          }
          this.deleteing = true
          NormcaseService.delete({
            id: this.id
          }).then(() => {
            this.$message({
              message: '成功删除分享病例',
              type: 'success'
            })
            this.backPage()
          }).catch(error => {
            this.$message.error(error || '删除分享病例失败')
          }).finally(() => {
            this.deleteing = false
          })
        },
        newRemark(editList){
            editList.forEach((item, i)=>{
                if(item.remark !== undefined && item.remark !== null){
                   var reg = new RegExp("&nbsp;","g");
                   this.editList[i].newRemark = item.remark.replace(/<[^>]+>/g, "").replace(reg,"");
                }else{
                   this.editList[i].newRemark = '';
                }
            });
        }
      },
      filters: {}
    }
  </script>
  
  <template>
    <el-container
    >
      <el-header height="45px" class="clear">
        <el-form :inline="true" class="demo-form-inline left-form" size="small">
          <el-form-item>
            <el-button @click="backPage">返 回</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="preview">预 览</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="save" :loading="saving" :disabled="saving">保 存</el-button>
          </el-form-item>
          <el-form-item v-if="id && id > 0">
            <el-button type="danger" @click="deleteNc" :loading="deleteing" :disabled="deleteing">删 除</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="share">分 享</el-button>
          </el-form-item> -->
        </el-form>
      </el-header>
      <el-main class="flex-disply">
        <div class="main-container clear">
          <div class="edit-wrap">
            <div class="edit-left fl">
              <div class="edit-header" @click="editType = -1">
                <h2 class="edit-title">{{normcase.title || '点击编辑'}}</h2>
                <div class="edit-nc">
                  <div class="edit-nc-item clear" v-if="!!normcase.sex || !!normcase.age">
                    <span class="lable">患者</span>
                    <span class="text">
                      <span v-if="!!normcase.sex">{{ normcase.sex % 2 === 0 ? '女' : '男' }}</span>
                      <span v-if="!!normcase.age">{{ normcase.age }}岁</span>
                    </span>
                  </div>
                  <div class="edit-nc-item clear">
                    <span class="lable">诊断</span>
                    <span class="text">{{normcase.standardDiseaseNames || normcase.diagnoseNames || '无'}}</span>
                  </div>
                  <div class="edit-nc-item clear">
                    <span class="lable">术式</span>
                    <span class="text">{{normcase.operatingNames || '无'}}</span>
                  </div>
                </div>
                <div class="edit-doctor">
                  <div class="edit-doctor-wrap clear">
                    <div class="doctor-img fl">
                      <img :src="normcase.operatorImage | headimgFilter">
                    </div>
                    <div class="doctor-info fl">
                      <span class="doctor-name">{{normcase.operatorName}}</span>
                      <span class="doctor-org">
                        <span v-if="normcase.hname">{{normcase.hname}}</span>
                        <span v-if="normcase.orgName"> . {{normcase.orgName}}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="edit-list-wrap">
                <div class="edit-list-scrollbar-wrap">
                  <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
                    <div class="p10">
                      <draggable v-model="editList" :options="draggableOptions" @end="handleMoveEnd">
                        <transition-group
                          tag="ul"
                          class="edit-paragraph-list"
                          name="edit-paragraph-list-group">
                          <li
                            v-for="(item, index) in editList"
                            :key="item.id || index"
                            class="paragraph-item draggable-item"
                            tabindex="0">
                            <div class="paragraph-wrap" :class="{current: editType === index}" @click="selectParagraph($event, index)">
                              <div class="clear content">
                                <a href="javascript:void(0)" @click="del($event, index)" class="del-icon"><i class="el-icon-remove-outline"></i></a>
                                <div class="paragraph-thumbnail fl">
                                  <img :src="item.thumbnail | imageParagraphFilter">
                                </div>
                                <div class="paragraph-remark fl">
                                 <!--取消掉标签-->
                                  <p v-bind="newRemark(editList)">{{item.newRemark}}</p>
                                </div>
                              </div>
                            </div>
                            <!-- <div class="add-section" v-if="editType === index">
                              <a href="javascript:void(0)" @click="add($event, index)" class="add-icon"><i class="far fa-plus-square"></i></a>
                            </div> -->
                          </li>
                        </transition-group>
                      </draggable>
                    </div>
                  </el-scrollbar>
                </div>
              </div>
            </div>
            <div class="edit-right fl">
              <div v-if="editType === null" class="edit-list-scrollbar-wrap">
                <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
                  <databank-normcase-show :normcase="normcase" :paragraphs="editList"></databank-normcase-show>         
                </el-scrollbar>
              </div>
              <div class="edit-main" v-else>
                <div v-if="editType === -1">
                  <databank-normcase-edit v-model="normcase"></databank-normcase-edit>
                </div>
                <div style="height:100%" v-else>
                  <!--工具栏-->
                    <eber-tools ref="tools" :focusIndex="focusIndex" :toolsClass="toolsClass"></eber-tools>
                    <!--编辑中心-->
                    <div class="main-center" ref="paragraph_List">
                        <div class="paragraph_add" style="width: 100%;height: 100%;overflow-y: auto;">
                            <div class="main-paragraph" v-for="(item, index) in editList" :index="index" :key="item.index">
                                <eber-sidebar :index="index" @add="add" @uploadFiles="uploadFiles"></eber-sidebar>
                                <eber-paragraph :index="index" :item="item" 
                                                @changeLeft="changeLeft" 
                                                @uploadFiles="uploadFiles"
                                                @delPic="delPic" 
                                                :focusIndex='focusIndex' 
                                                @toolStyle="toolStyle" 
                                                :percentage="percentage">
                                </eber-paragraph>
                            </div>
                            <eber-sidebar :index="editList.length" @add="add" @uploadFiles="uploadFiles"></eber-sidebar>    
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </template>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    .main-container {
      width: 1024px;
      height: auto;
      margin: 0 auto;
      padding: 0;
    }
    .edit-wrap {
      width: 100%;
      height: 100%;
      padding: 10px 30px;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      -o-box-sizing: border-box;
      -ms-box-sizing: border-box;
    }
    .edit-left,
    .edit-right {
      width: 362px;
      height: 100%;
      position: relative;
      border-radius: 12px;
      border: 1px solid #e1e6eb;
      background: transparent;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      -o-box-sizing: border-box;
      -ms-box-sizing: border-box;
    }
    .edit-left {
      width: 362px;
    }
    .edit-right {
      width: 572px;
      margin-left: 30px;
    }
    .edit-header {
      width: 100%;
      height: 220px;
      cursor: pointer;
      background-position: center;
      background-repeat: no-repeat;
      overflow: hidden;
      position: relative;
      background-size: cover;
      border-bottom: 1px solid #e1e6eb;
      box-sizing: border-box;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .edit-header h2 {
      margin: 11px 8px 10px 14px;
      font-size: 20px;
      color: #aaa;
      /*text-shadow: 0px 1px 1px #333;*/
      word-break: break-all;
      word-wrap: break-word;
      white-space: pre-wrap;
      text-align: start;
      display: -webkit-box;
      -webkit-box-orient: horizontal;
      text-overflow: ellipsis;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .edit-nc {
      overflow: hidden;
      padding: 0 10px 10px 10px;
      background: transparent;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      -o-box-sizing: border-box;
      -ms-box-sizing: border-box;
    }
    .edit-nc-item {
      width: 100%;
      margin-bottom: 5px;
      line-height: 18px;
    }
    .edit-nc-item .lable {
      width: 40px;
      text-align: left;
      float: left;
      color: #909399;
      padding: 0 8px 0 0;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    .edit-nc-item .text {
      display: block;
    }
    .edit-nc-item span.text {
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
      -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
      -webkit-line-clamp: 1; /** 显示的行数 **/
      overflow: hidden;  /** 隐藏超出的内容 **/
    }
    .edit-nc-item .text span {
      margin-right: 10px;
    }
    .edit-doctor {
      width: 100%;
      height: 93px;
      padding: 10px;
      border-top: 1px solid #e1e6eb;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      -o-box-sizing: border-box;
      -ms-box-sizing: border-box;
    }
    .edit-doctor-wrap {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
    }
    .edit-doctor .doctor-img {
      width: 32px;
      height: 32px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .edit-doctor .doctor-img img {
      width: 32px;
      height: 32px;
      display: block;
      border-radius: 50%;
      background: #409EFF;
      text-align: center;
      line-height: 32px;
      font-size: 32px;
      color: #F2F6FC;
      overflow: hidden;
    }
    .edit-doctor .doctor-info {
      width: 100%;
      height: 100%;
      position: relative;
      padding: 0 0 0 50px;
      font-size: 14px;
      color: #909399;
      line-height: 32px;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      -o-box-sizing: border-box;
      -ms-box-sizing: border-box;
    }
    .edit-doctor .doctor-info .doctor-name {
      display: block;
      font-size: 18px;
      color: #333;
    }
    .edit-doctor .doctor-info .doctor-org {
      display: block;
    }
    .edit-main {
      width: 100%;
      height: 100%;
      padding: 10px;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      -o-box-sizing: border-box;
      -ms-box-sizing: border-box;
      overflow: hidden;
    }
    .edit-list-wrap {
      width: 100%;
      height: 100%;
      padding-top: 220px;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      -o-box-sizing: border-box;
      -ms-box-sizing: border-box;
    }
    .edit-list-scrollbar-wrap {
      width: 100%;
      height: 100%;
    }
    .paragraph-item:focus {
      border: 0px solid #e1e6eb;
      outline-width: 0;
    }
    .paragraph-item .paragraph-wrap {
      width: 100%;
      display: block;
      position: relative;
      /*height: 110px;*/
      cursor: pointer;
      margin-bottom: 10px;
      border: 1px solid #e1e6eb;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      -o-box-sizing: border-box;
      -ms-box-sizing: border-box;
    }
    .paragraph-item .paragraph-wrap.current {
      margin-bottom: 0;
      border: 1px solid #409EFF;
    }
    .paragraph-item .paragraph-wrap .content {
      padding: 16px 10px 16px 22px;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      -o-box-sizing: border-box;
      -ms-box-sizing: border-box;
    }
    .paragraph-thumbnail {
      width: 76px;
      height: 76px;
      position: relative;
      border: 1px solid #e1e6eb;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      -o-box-sizing: border-box;
      -ms-box-sizing: border-box;
    }
    .paragraph-thumbnail img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 0;
      display: block;
      margin: auto;
      padding: auto;
    }
    .paragraph-remark {
      width: 220px;
      height: 76px;
      overflow: hidden;
      line-height: 19px;
      cursor: pointer;
      border: 1px solid rgba(255, 255, 255, .0);
      padding: 0px 4px;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      -o-box-sizing: border-box;
      -ms-box-sizing: border-box;
    }
    .paragraph-remark p {
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
      -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
      -webkit-line-clamp: 4; /** 显示的行数 **/
      overflow: hidden;  /** 隐藏超出的内容 **/
    }
    .paragraph-wrap .del-icon {
      width: 18px;
      height: 18px;
      position: absolute;
      left: 1px;
      top: -1px;
      color: #FF0000;
      font-weight: 400;
      font-size: 20px;
    }
    .add-section {
      width: 100%;
      margin: 8px 0;
      text-align: center;
    }
    .add-section .add-icon {
      width: 18px;
      height: 18px;
      font-size: 20px;
      font-weight: 400;
      color: #aaa;
    }
    .main-paragraph{
      width: 100%;
      overflow: hidden;
  }
    .main-center{
      width: 100%;
      height: 92%;
      overflow: hidden;
  }
  </style>
  